import { cn } from "@/lib/utils";
import React from "react";
import { Input } from "../ui/input";

type InputDialogProps = {
  validationError: string | null;
  placeholder?: string;
  isBiggerInput?: boolean;
  inputSize?: "sm" | "md" | "lg";
  disablePlaceholderAnimation?: boolean;
  inputValue: string | null;
  setValidationError: (error: string | null) => void;
  setInputValue: (value: string) => void;
  id: string;
  validationType?: "numbers" | "alphanumeric" | "all" | "phone";
  readOnly?: boolean;
};

export const InputDialog: React.FC<InputDialogProps> = (
  props: InputDialogProps
) => {
  const {
    validationError,
    setValidationError,
    setInputValue,
    placeholder,
    isBiggerInput,
    inputSize,
    inputValue,
    disablePlaceholderAnimation = true,
    id,
    validationType = "all",
    readOnly = false,
  } = props;

  const validateInput = (value: string): boolean => {
    switch (validationType) {
      case "numbers":
        return /^\d*\.?\d*$/.test(value);
      case "alphanumeric":
        return /^[a-zA-Z0-9.]*$/.test(value);
      case "phone":
        return /^\+?[0-9]*$/.test(value);
      case "all":
        return true;
      default:
        return true;
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (validateInput(value)) {
      setInputValue(value);
      if (validationError) {
        setValidationError(null);
      }
    }
  };

  return (
    <div>
      <Input
        id={id}
        type="text"
        styleLable={{
          color: validationError && "red",
        }}
        placeholder={placeholder}
        disablePlaceholderAnimation={disablePlaceholderAnimation}
        className={cn(
          "w-full rounded-[10px] bg-[#00000000]",
          inputSize === "sm" && "text-[12px] p-[12px] h-[36px]",
          isBiggerInput && "leading-[24px]",
          validationError && "border-[red] focus:border-[red]"
        )}
        value={inputValue ?? undefined}
        inputSize={inputSize}
        onChange={handleInputChange}
        readOnly={readOnly}
      />
      {validationError && (
        <p
          id={`${id}_error`}
          className="text-red-500 text-[15px] font-medium ml-4"
        >
          {validationError}
        </p>
      )}
    </div>
  );
};
